import { Grid } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import * as React from "react";
import { Button, useRefresh } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSubmit from "../../unit/CustomButtonSubmit";
import CustomDialogTitle from "../../unit/CustomDialogTitle";
import HeaderLabelTitle from "../../unit/HeaderLabelTitle";
import useNotify from "../../unit/useNotify";
import DialogApplicationBaseInfo from "../DialogApplicationBaseInfo";
import CustomApplicationDialogTitle from "./CustomApplicationDialogTitle";

export default function CustomRejectFormDialog({ ...props }) {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const { appId, record } = props;
  const [open, setOpen] = React.useState(false);
  const refresh = useRefresh();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    refresh();
  };

  return (
    <React.Fragment>
      <Button
        id="btn-application-reject"
        label="Reject"
        color="error"
        variant="contained"
        size="medium"
        sx={{
          marginLeft: "10px",
          width: "120px",
          color: "#e9fce7",
        }}
        onClick={handleClickOpen}
      />
      <Dialog
        id="dialog-application-reject"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="sm"
        PaperProps={{
          component: "form",
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries((formData as any).entries());
            const notes = formJson.notes;
            // infoNotify("development in progress");

            const reqUrl = `applications/actions/review/reject`;
            const response = await sendRequest(reqUrl, {
              id: appId,
              data: formJson,
            });
            if (response && response.status == "200") {
              successNotify("Data saved successfully");
              handleClose();
              if (props.cb) {
                props.cb("New");
              }
            } else {
              errorNotify(response?.message || "Data not saved!");
            }
          },
        }}
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #e5e5e5",
            mb: 2,
          }}
        >
          <CustomApplicationDialogTitle record={record} subTitle="Reject" />
        </DialogTitle>
        <DialogContent>
          <DialogContentText></DialogContentText>
          <DialogApplicationBaseInfo appId={appId} record={record} />
          <Grid container sx={{ mb: 1, pb: 1 }}>
            <Grid sx={{ mb: 2 }} container>
              <HeaderLabelTitle
                title="Please Fill In Reason For Rejection"
                required
              />
            </Grid>
            <Grid sx={{ mb: 2 }} container>
              <TextField
                required
                id="rejectreason"
                name="rejectreason"
                placeholder="Notes"
                multiline={true}
                minRows={1}
                fullWidth
                variant="outlined"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={handleClose} />
          <CustomButtonSubmit label="Reject" color="error" />
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
